module.exports = __webpack_public_path__ + "static/3-9e5cb92da755846555e99fb4b1181640.jpg";